import React from 'react';
import './StatStrip.css';
import { t } from './i18n';

function formatKm(km) {
  if (!km) return '0';
  if (km < 10) return km.toFixed(1);
  return String(Math.round(km));
}

function StatStrip({ distanceKm = 0, places = 0, streakDays = 0, shows = 0 }) {
  const items = [
    { label: t('web.stat.distance'), value: formatKm(distanceKm), unit: 'km' },
    { label: 'Lugares', value: String(places), unit: '' },
    { label: t('web.stat.streak'), value: String(streakDays), unit: 'dias' },
    { label: 'Shows', value: String(shows), unit: '' },
  ];

  return (
    <div className="stat-strip" aria-label="{t('web.print.periodSummary')}">
      {items.map((item) => (
        <div className="stat-chip" key={item.label}>
          <span className="stat-chip-label">{item.label}</span>
          <span className="stat-chip-value">
            {item.value}
            {item.unit && <small> {item.unit}</small>}
          </span>
        </div>
      ))}
    </div>
  );
}

export default StatStrip;
